import { useQuery } from '@tanstack/react-query'
import { surveyKeys } from 'pages/Survey/hooks/surveyKeys'
import { Survey } from 'pages/Survey/types'
import { getRequest } from 'utils/api/apiRequest'

export const useGetSurvey = (surveyId?: number) => {
  return useQuery({
    enabled: !!surveyId,
    queryKey: surveyKeys.getById(surveyId),
    queryFn: () => getRequest<Survey>(`/user-surveys/${surveyId}`),
    select: (data) => data?.data,
  })
}
